const rideStatusValues = {
    searching: "searching",
    reaching: "reaching",
    dropping: "dropping",
    reached: "reached"
} 

export default rideStatusValues;